// Activates iframes authored with `data-src` instead of `src` (e.g. the Sketchfab embed in the
// homepage custom-liquid section, whose markup lives in templates/index.json and is not versioned).
// Loading is delayed until the iframe scrolls near the viewport.
(function () {
  function activate(frame) {
    if (frame.getAttribute('src')) return;
    if (!frame.getAttribute('allow')) {
      frame.setAttribute('allow', 'autoplay; fullscreen; xr-spatial-tracking');
    }
    frame.setAttribute('src', frame.getAttribute('data-src'));
  }

  function init() {
    var frames = document.querySelectorAll('iframe[data-src]:not([src])');
    if (!frames.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(frames, activate);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activate(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '200px' }
    );

    Array.prototype.forEach.call(frames, function (frame) {
      observer.observe(frame);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
